import { RouterProvider } from 'react-router-dom';
import { HelmetProvider, ErrorBoundary, QueryClientProvider, ToastProvider } from '@/app/providers';
import { DataProvider } from './contexts/DataContext';
import { router } from './app/router/routes';

/**
 * App — the React tree.
 *
 * `main.tsx` owns browser-side bootstrap (Sentry, async auth-storage init,
 * service worker). This file owns the provider tree + RouterProvider so the
 * shape matches PE's `src/App.tsx` and is symmetric to the other apps.
 *
 * Provider chain (top → bottom): Helmet → ErrorBoundary → QueryClient →
 * Data → Router + Toast. `<DataProvider>` is app-specific cross-cutting
 * context and stays under `src/contexts/`; everything else lives under
 * `src/app/providers/` per ARCHITECTURE.md.
 */
export function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <QueryClientProvider>
          <DataProvider>
            <RouterProvider router={router} />
            <ToastProvider />
          </DataProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
